module.exports = "<fieldset> <legend translate>app.roles</legend> <div class=\"form-field checkbox\" ng-repeat=\"role in roles\"> <label> <input type=checkbox checklist-model=model checklist-value=role.name> {{role.display_name}} </label> </div> </fieldset> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/directives/filter-system/filter-role.html
// module id = 521
// module chunks = 0